import { render, staticRenderFns } from "./TabBeneficiaryHistoryPPP3Budget.vue?vue&type=template&id=2f12b593"
import script from "./TabBeneficiaryHistoryPPP3Budget.vue?vue&type=script&lang=js"
export * from "./TabBeneficiaryHistoryPPP3Budget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports